var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 1.875H10.875V1.25C10.875 0.90625 10.5938 0.625 10.25 0.625C9.90625 0.625 9.625 0.90625 9.625 1.25V1.875H3.375V1.25C3.375 0.90625 3.09375 0.625 2.75 0.625C2.40625 0.625 2.125 0.90625 2.125 1.25V1.875H1.5C0.8125 1.875 0.25 2.4375 0.25 3.125V13.125C0.25 13.8125 0.8125 14.375 1.5 14.375H11.5C12.1875 14.375 12.75 13.8125 12.75 13.125V3.125C12.75 2.4375 12.1875 1.875 11.5 1.875ZM10.875 13.125H2.125C1.78125 13.125 1.5 12.8438 1.5 12.5V5H11.5V12.5C11.5 12.8438 11.2188 13.125 10.875 13.125Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.344c4188ceb1ad8355b7323a34ab62c2.svg";
export { ForwardRef as ReactComponent };